export const System = {
  /**
   * 진동
   * @param {} duration
   */
  vibrate: function (duration) {
    window.Native.execute('hybrid', 'vibrate', duration)
  },
  /**
   * 전화걸기
   * @param {*} tel
   */
  call: function (tel) {
    window.Native.execute('hybrid', 'callPhone', tel)
  },
}

export const Data = {
  global: function (key, value) {
    if (arguments.length == 2) {
      var params = {
        key: key,
        value: value,
      }
      window.Native.execute('hybrid', 'setGlobalData', params)
    } else if (arguments.length == 1) {
      // if (typeof key == "object")
      // 		execute("setGlobalData", key)
      // else
      // @returns string 문자열
      return window.Native.execute('hybrid', 'getGlobalData', key)
    }
    // else
    // return execute("getGlobalData", "")
  },
  removeGlobal: function (key) {
    if (arguments.length == 1) window.Native.execute('hybrid', 'removeGlobalData', key)
    // 메모리 데이터 전체 삭제
    // else
    // Lina.execute("removeGlobalData", {})
  },
  storage: function (key, value) {
    if (arguments.length == 2) {
      var params = {
        key: key,
        value: value,
      }
      window.Native.execute('hybrid', 'setStorageData', params)
    } else if (arguments.length == 1) {
      // @returns string 문자열
      return window.Native.execute('hybrid', 'getStorageData', key)
    }
    // else
    // 		return execute("getStorageData")
  },
  removeStorage: function (key) {
    if (arguments.length == 1) window.Native.execute('hybrid', 'removeValueFromStorage', key)
    // else
    // Lina.execute("removeGlobalData", {})
  },
}

export const Device = {
  /**
   * Device h/w 정보 반환
   * @returns 
    {
      "model": "sdk_gphone64_arm64",
      "os": {
        "name": "android",
        "version": "13"
      },
      "display": {
        "width": 1080,
        "height": 2340,
        "dpi": 440
      }
    }
   */
  info: function () {
    return window.Native.execute('hybrid', 'getDeviceInfo')
  },

  /**
   * 디바이스 OS 반환
   * @param {*} os
   * @returns Android / iOS
   */
  os: function (os) {
    return window.Native.navigator.os(os).toLowerCase()
  },

  /**
   * Native 앱에서 실행 여부 반환
   * @returns true / false
   */
  inApp: function () {
    return window.Native.navigator.inApp()
  },
}

export const App = {
  /**
   * 앱의 기본적인 정보를 반등
   * (버전 / 운영체체 등)
   * @param {*} os 
   * @returns 
      {
        "id": "com.cjfreshway.fsmn.mobile.dev",
        "name": "FreshwayFsmns",
        "version": "0.8.0-dev",
        "build": "1"
      }
  */
  info: function () {
    return window.Native.execute('hybrid', 'getAppInfo')
  },

  /**
   * 앱 종료
   */
  finish: function () {
    window.Native.execute('hybrid', 'finishApp')
  },

  /**
   * Toast 메시지 노출
   * @param {*} message
   * @param {*} duration
   */
  toast: function (message, duration) {
    const payload = {
      message: message,
      duration: !duration ? 2000 : duration,
    }

    window.Native.execute('hybrid', 'showToast', payload)
  },

  /**
   * 새 webview를 가진 화면을 호출
   * @param {*} targetUrl
   */
  openNewWebView: function (method, url, params, isBackHistory, callback) {
    const payload = {
      method: method,
      url: url,
      params: params,
      isBackHistory: isBackHistory,
    }
    window.Native.execute('hybrid', 'openNewWebView', payload, callback)
  },

  /**
   * openNewWebView로 열린 webview 닫기
   * @param {*} payload json object
   */
  closeNewWebView: function (payload) {
    window.Native.execute('hybrid', 'closeNewWebView', payload)
  },

  /**
   * 외부 또는 내부 브라우저를 주어진 url로 호출
   * @param {*} browserType "browser" or "inapp"
   * @param {*} externalLink
   */
  openExternalLink: function (browserType, externalLink) {
    const payload = {
      type: browserType,
      link: externalLink,
    }
    window.Native.execute('hybrid', 'openExternalLink', payload)
  },
}
